import React, {useState, useEffect} from "react"
import styled from "styled-components"
import SoloOrDuo from "./SoloOrDuo/SoloOrDuo"

const Styled ={
    TitleFont:styled.p`
        font-size:32px;
        font-family:"Jua", sans-serif;
        color:#000;
        font-weight: 500;
        text-align: center;
    `,
    LittleTitleFont:styled.p`
        font-size:26px;
        font-family:"Jua", sans-serif;
        color:#000;
        font-weight: 500;
        text-align: center;
    `,
    StartBtn:styled.div`
        width:350px;
        height:50px;
        border-radius: 50px;
        background-color:yellowgreen;
        display:flex;
        justify-content: center;
        align-items: center;
        :hover{
            opacity:50%;
        }
    `,
    SituationBtnWrap:styled.div`
        width:100%;
        display:flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: row;
    `,
}

const Start =()=>{
    const [StartFnc, setStartFnc] = useState<boolean>(false) //true면 시작
    const [Points, setPoints] = useState<number>(0)
    const Wrap = styled.div`
            width:400px;
            height:650px;
            display:flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
    `
    if(StartFnc === false){
        //시작 페이지
        return(
            <Wrap>
                <Styled.TitleFont>우리 부부의 청약점수는??</Styled.TitleFont>
                <Styled.LittleTitleFont>신혼부부를 위한<br /> 간단하게 청약 점수 계산하기</Styled.LittleTitleFont>
                <Styled.StartBtn onClick={()=>{setStartFnc(!StartFnc)}}>
                    <Styled.LittleTitleFont>시작!</Styled.LittleTitleFont>
                </Styled.StartBtn>
            </Wrap>
        )
    }else{
        //시작버튼 누름
        return(
            <SoloOrDuo 
                Points={Points} 
                setPoints={setPoints}
            />
        )
    }
    
}
export default Start